module.exports = __webpack_public_path__ + "img/menu_ladies_tenteki.3fe22ed5.png";